module.exports = __webpack_public_path__ + "static/media/INGshake_cropped_mini.030edb5c.jpg";